import { render, staticRenderFns } from "./ReglaArea.vue?vue&type=template&id=32a516a4&"
import script from "./ReglaArea.vue?vue&type=script&lang=js&"
export * from "./ReglaArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports